import React from 'react';
import download from '../img/file-download-line.png'
import api from '../apiConnector'

export default class FrontDocuments extends React.Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        const {devis,branch} = this.props.container
        const forbiddenNames = (branch=='axa')?
            ['BON_COM','Commissionnement','Lettre recommandée Hamon','Mémo véhicule assuré','Lettre de résiliation']
            : ['BON_COM','Commissionnement','Lettre recommandée Hamon']
        const documents = devis.documents.filter( 
            doc => { return !forbiddenNames.some(pattern => doc.name && doc.name.includes(pattern)); }
        ).sort((a, b) => {
            const target = "Lettre d'accompagnement";
            return (b.name === target) - (a.name === target) || a.name.localeCompare(b.name);
        });

        return <>{documents.map( doc => 
            <a key={doc.name} className="document_download" href={api.downloadDocument(devis.typedId(),doc.name)}><img src={download}/> {doc.name}</a>
        )}</>
    }
}